import { render, staticRenderFns } from "./Colorscheme.vue?vue&type=template&id=1b2c512a&"
import script from "./Colorscheme.vue?vue&type=script&lang=js&"
export * from "./Colorscheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports